import { createAsyncThunk } from '@reduxjs/toolkit'
import { API_URL } from '../../config'
export const AppReg = createAsyncThunk(
    'AppRegister', async (data) => {
        // console.log("this is data", data)
        const { email, password, fatherName, contactno, name, cnic } = data
        // console.log('this is destructure data', email, password, fatherName, contactno, name, cnic)

        try {
            const res = await fetch(`${API_URL}/appsignup`, {
                method: "post",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    email, password, fatherName, contactno, name, cnic
                })
            })
            const result = await res.json()

            return result

        } catch (error) {
            // toast.error(error)
            console.log(error)
        }

    }
)
export const AppLogin = createAsyncThunk(
    'AppLogin', async (data) => {
        // console.log("this is data", data)
        const { email, password } = data
        // console.log('this is destructure data', email, password)

        try {
            const res = await fetch(`${API_URL}/appsignin`, {
                method: "post",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    email, password
                })
            })
            const data = await res.json()


            // console.log("response", data)
            if (res.status === 200) {
                localStorage.setItem('token', data.token)
                localStorage.setItem('userdetail', JSON.stringify(data.AppUser))
            }
            return data

        } catch (error) {
            // toast.error(error)
            console.log(error)

        }

    }
)